import { useQuery } from "@tanstack/react-query";
import { ChargeLayer } from "../../models/ChargeLayer";
import { getChargeLayers } from "../../repositories/ChargeRepository";

export const useChargeLayersQuery = (
  chargeId: number | null | undefined,
  refetchInterval: number = 0,
) => {
  return useQuery({
    queryKey: ["charge-layers", chargeId],
    queryFn: async ({ signal }) => {
      const resp = await getChargeLayers(chargeId!, signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as ChargeLayer[];
      }
      throw new Error(resp.message);
    },
    enabled: !!chargeId,
    refetchInterval: refetchInterval > 0 ? refetchInterval * 1000 : false,
  });
};
